export const stringifySafe = (v: any) => {
  try { return typeof v === 'string' ? v : JSON.stringify(v, null, 2); }
  catch { return String(v); }
};